import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f3abc50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Content", -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Colors", -1))
const _hoisted_5 = { class: "d-flex flex-wrap" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Location", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Directory List", -1))
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "hide-required-asterisk": "",
    ref: "form",
    "label-position": "top",
    model: _ctx.signageItemLayoutData
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_button, {
        class: "float-end",
        onClick: _ctx.clearDirectoryHandler
      }, {
        default: _withCtx(() => [
          _createTextVNode("Clear Directory")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_el_form_item, {
          class: "col-lg-6",
          prop: "header",
          label: "Header"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.signageItemLayoutData.header,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signageItemLayoutData.header) = $event)),
              placeholder: "Header"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_divider, { class: "mt-0" }),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form_item, {
            class: "me-4",
            prop: "font",
            label: "Font Color"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.font,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.signageItemLayoutData.font) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            class: "me-4",
            prop: "backgroundColor",
            label: "Background Color"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.background,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.signageItemLayoutData.background) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            class: "me-4",
            prop: "roomNumberFont",
            label: "Room Number Font Color"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.roomNumberFont,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.signageItemLayoutData.roomNumberFont) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            class: "me-4",
            prop: "roomNumberBackground",
            label: "Room Number Background Color"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.roomNumberBackground,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.signageItemLayoutData.roomNumberBackground) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            prop: "directory",
            label: "Directory Color"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.directory,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.signageItemLayoutData.directory) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_ctx.signageItemLayoutData.column1, _ctx.signageItemLayoutData.column2], (column, index) => {
        return (_openBlock(), _createElementBlock("section", {
          key: index,
          class: "column-section"
        }, [
          _createElementVNode("h1", _hoisted_6, "Column " + _toDisplayString(index + 1), 1),
          _hoisted_7,
          _createVNode(_component_el_form_item, {
            class: "col-lg-6",
            prop: "location",
            label: "Location Name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: column.location,
                "onUpdate:modelValue": ($event: any) => ((column.location) = $event),
                placeholder: "Location"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          _hoisted_8,
          _createVNode(_component_draggable, {
            class: "p-0 m-0",
            handle: ".drag",
            modelValue: column.directory,
            "onUpdate:modelValue": ($event: any) => ((column.directory) = $event),
            tag: "ul",
            "item-key": "id"
          }, {
            item: _withCtx(({element, index}) => [
              _createElementVNode("li", {
                class: _normalizeClass(["d-flex align-items-center", { 'mb-2' : index < column.directory.length }])
              }, [
                _createVNode(_component_el_tooltip, {
                  effect: "dark",
                  content: "Reorder",
                  placement: "bottom",
                  "hide-after": 0,
                  "show-after": 500
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, {
                      class: "me-2 drag",
                      icon: _ctx.mdiDragHorizontalVariant
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_input, {
                  class: "flex-grow-1 m-0 me-2",
                  modelValue: element.name,
                  "onUpdate:modelValue": ($event: any) => ((element.name) = $event),
                  placeholder: "Name"
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_el_input, {
                  class: "flex-grow-1 m-0 me-2",
                  modelValue: element.roomNumber,
                  "onUpdate:modelValue": ($event: any) => ((element.roomNumber) = $event),
                  placeholder: "Room Number"
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_el_tooltip, {
                  effect: "dark",
                  content: "Duplicate",
                  placement: "bottom",
                  "hide-after": 0,
                  "show-after": 500
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: ($event: any) => (column.directory.splice(index, 0 , {...element})),
                      class: "dt-icon-button"
                    }, [
                      _createVNode(_component_Icon, { icon: _ctx.mdiContentDuplicate }, null, 8, ["icon"])
                    ], 8, _hoisted_9)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_el_tooltip, {
                  effect: "dark",
                  content: "Delete",
                  placement: "bottom",
                  "hide-after": 0,
                  "show-after": 500
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: ($event: any) => (column.directory.splice(index, 1)),
                      class: "dt-icon-button"
                    }, [
                      _createVNode(_component_Icon, { icon: _ctx.mdiClose }, null, 8, ["icon"])
                    ], 8, _hoisted_10)
                  ]),
                  _: 2
                }, 1024)
              ], 2)
            ]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"]),
          _createVNode(_component_el_button, {
            class: "mt-2",
            onClick: ($event: any) => (column.directory.push({ name: '', roomNumber: '' })),
            type: "primary",
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("Add Directory Item")
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["model"]))
}